import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { makeFormField, formatPhoneNumber, stripLeadingOnesAndZeros, stripNonNumerics, isValidPhoneNumber } from '@/helpers';
import { ErrorMode } from '@/models';
import { ui } from '@/constants';
import { ErrorEvent } from '@/services/analytics/events';

@Component({
    name: 'CmgCheckoutBadPhoneNumberModal',
})
export default class CmgCheckoutBadPhoneNumberModal extends Vue {
    isLoading = false;
    newPhoneNumber = makeFormField();

    get visible() {
        return this.$appStore.state.ui.modals.checkoutBadPhoneNumber.visible;
    }

    get args() {
        return this.$appStore.state.ui.modals.checkoutBadPhoneNumber.args;
    }

    get phoneNumber(): string | null {
        return (this.args && this.args.phoneNumber) || null;
    }

    get phoneInputMaxLength(): number {
        return this.newPhoneNumber.formatted ? 14 : 10;
    }

    get isMobile(): boolean {
        return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
    }

    formatPhoneNumber(value: string | null): string {
        return formatPhoneNumber(value || '');
    }

    sanitizePhoneNumber(value: string | null): string {
        return stripLeadingOnesAndZeros(stripNonNumerics(value || ''));
    }

    validatePhoneNumber(): boolean {
        this.newPhoneNumber.error = '';
        this.newPhoneNumber.dirty = true;

        if (!this.newPhoneNumber.value) {
            this.newPhoneNumber.error = 'New Number is required';
            this.newPhoneNumber.errorMode = ErrorMode.PlaceHolder;
        } else if (!isValidPhoneNumber(this.newPhoneNumber.value)) {
            this.newPhoneNumber.error = 'Invalid phone number';
            this.newPhoneNumber.errorMode = ErrorMode.BelowField;
        }

        return !this.newPhoneNumber.error;
    }

    async onSave() {
        if (!this.validatePhoneNumber()) {
            return;
        }

        const order = this.$services.order.getCurrentOrder();
        const delivery = order && order.order.delivery;

        if (!order || !delivery) {
            this.onClose();
            return;
        }

        try {
            this.isLoading = true;
            await this.$services.order.updateDeliveryDropoffInfoOnOrder(order, {
                ...delivery,
                dropOffContactPhoneNumber: this.newPhoneNumber.value,
            });

            this.setDeliveryPhoneNumbers(this.newPhoneNumber.value);
        } catch (e: any) {
            this.$services.ui.setModalVisibility('globalErrorToast', true);
        } finally {
            this.isLoading = false;
        }
        this.onClose();
    }

    async setDeliveryPhoneNumbers(phoneNumber: string) {
        const profile = this.$appStore.state.customer.profile;
        const deliveryAddress = this.$appStore.state.order.selectedDeliveryAddress;

        if (profile && profile.isGuest) {
            this.$services.checkout.setGuestInfoPhoneNumber(this.newPhoneNumber.value);
        } else if (profile && !profile.isGuest && deliveryAddress) {
            deliveryAddress.phoneNumber = this.newPhoneNumber.value;
            await this.$services.customer.updateCustomerDeliveryAddress(deliveryAddress);
        }

        this.$services.order.setOrderPhoneNumber(this.newPhoneNumber.value);
        this.$services.checkout.setDeliveryPhoneNumber(this.newPhoneNumber.value);
    }

    onClose() {
        this.$services.ui.setModalVisibility('checkoutBadPhoneNumber', false);
        this.$services.ui.focusBack();
    }
}
